var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.4995C13.35 16.4995 16.5 13.3495 16.5 9.49951C16.5 5.64951 13.35 2.49951 9.5 2.49951C5.65 2.49951 2.5 5.64951 2.5 9.49951C2.5 13.3495 5.65 16.4995 9.5 16.4995ZM9.5 0.749512C14.3125 0.749512 18.25 4.68701 18.25 9.49951C18.25 14.312 14.3125 18.2495 9.5 18.2495C4.6875 18.2495 0.75 14.312 0.75 9.49951C0.75 4.68701 4.6875 0.749512 9.5 0.749512ZM9.9375 10.1995L5.7375 12.6495L5.125 11.4245L8.625 9.41201V5.12451H9.9375V10.1995Z",
    fill: "#FF5E43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32);
export default __webpack_public_path__ + "static/media/icon32.bffd3e5851e0b9fd74675b1c0ede913d.svg";
export { ForwardRef as ReactComponent };